// AI-assisted email template drafter — modal on the EmailTemplate form.
//
// The modal (rendered by the form partial with id="ai-draft-modal") has a
// purpose <select>, a tone <select>, an optional custom_prompt <textarea>,
// and a submit button. On click we POST to /email_templates/ai_draft and
// drop the returned subject/body into the corresponding form inputs.
//
// Rails-UJS's jQuery ajaxPrefilter handles CSRF automatically. Buttons show
// a busy state during the round-trip; a dismissable inline alert surfaces
// errors without wiping the form.

import $ from 'jquery';

function setBusy($btn, busy){
  if (busy){
    $btn.prop('disabled', true);
    $btn.data('orig-text', $btn.text());
    $btn.text($btn.data('busy-text') || '…');
  } else {
    $btn.prop('disabled', false);
    var t = $btn.data('orig-text');
    if (t) $btn.text(t);
  }
}

function showError($modal, msg){
  var $err = $modal.find('.ai-draft-error');
  if ($err.length === 0){
    $err = $('<div class="ai-draft-error alert alert-warning mt-2 mb-0"></div>');
    $modal.find('.modal-body').append($err);
  }
  $err.text(msg).show();
}

function clearError($modal){
  $modal.find('.ai-draft-error').remove();
}

// When the server returns 429 with quota_exceeded=true, disable the modal's
// submit button + the "Draft with AI" trigger button for the rest of the
// session. Recruiter can still type email templates by hand — only the AI
// entry point is gated. Matches the marketing FAQ promise ("buttons stay
// visible but temporarily inactive with a tooltip").
function disableAiDraftAfterQuota(msg){
  $('.ai-draft-submit, [data-bs-target="#ai-draft-modal"]')
    .prop('disabled', true)
    .attr('title', msg)
    .addClass('ai-quota-exhausted');
}

function parseAjaxError(xhr){
  var out = { message: 'AI request failed.', quotaExceeded: false };
  try {
    var payload = JSON.parse(xhr.responseText || '{}');
    if (payload.error) out.message = payload.error;
    if (payload.quota_exceeded) out.quotaExceeded = true;
  } catch(_e){}
  if (xhr.status === 429 && !out.quotaExceeded) {
    out.quotaExceeded = /token|quota|budget|额度|用完/i.test(out.message);
  }
  return out;
}

function writeToForm(subject, body){
  // simple_form generates ids like #email_template_subject and _body
  $('#email_template_subject').val(subject);
  $('#email_template_body').val(body).trigger('change');
}

function onSubmit(e){
  e.preventDefault();
  var $btn    = $(this);
  var $modal  = $btn.closest('#ai-draft-modal');
  clearError($modal);

  var payload = {
    purpose:       $modal.find('#ai-draft-purpose').val(),
    tone:          $modal.find('#ai-draft-tone').val(),
    custom_prompt: $modal.find('#ai-draft-custom-prompt').val() || '',
  };

  if (!payload.purpose){
    showError($modal, $modal.data('no-purpose-msg') || 'Please pick a purpose.');
    return;
  }

  setBusy($btn, true);
  $.ajax({
    url:      '/email_templates/ai_draft',
    type:     'POST',
    dataType: 'json',
    data:     payload,
    success:  function(resp){
      writeToForm(resp.subject, resp.body);
      // Close the modal via BS5 API (see jquery_global.js — bare .modal()
      // instantiates without showing, .modal('hide') hides an existing one).
      $modal.modal('hide');
    },
    error:    function(xhr){
      var parsed = parseAjaxError(xhr);
      showError($modal, parsed.message);
      if (parsed.quotaExceeded) disableAiDraftAfterQuota(parsed.message);
    },
    complete: function(){ setBusy($btn, false); },
  });
}

function init(){
  $(document)
    .off('click.aiDraft', '.ai-draft-submit')
    .on('click.aiDraft',  '.ai-draft-submit', onSubmit);
}

$(document).ready(init);

export { init };
